/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

import { createAsyncAction } from 'Helpers/redux'
import { apiCall } from './api'

export const GET_RANKS = createAsyncAction('GET_RANKS')
export const getRanks = () =>
  apiCall({
    method: 'get',
    endpoint: '/curator/ranks',
    types: GET_RANKS,
  })
